// deps
import React, { memo, ReactElement } from "react";
import classNames from "classnames";

// styles
import styles from "./styles.scss";
import { withStyles } from "@swiggy-private/core-ui";

// test-ids
import { LOADING_SCREEN_TEST_IDS } from "@swiggy-private/payment-test-ids";

interface InitalLoadingScreenProps {
    className?: string;
}

const Title = memo(function Title({ lineWidth = 30 }: { lineWidth?: number }): ReactElement {
    return <div className={styles.title} style={{ width: `${lineWidth}%` }}></div>;
});

function SwiggyMoneyLoadingScreen(props: InitalLoadingScreenProps): ReactElement {
    const containerClass = classNames(styles.orderContainer, props.className);

    return (
        <>
            <div className={containerClass} data-testid={LOADING_SCREEN_TEST_IDS.CONTAINER}>
                <div className={styles.infoHeaderContainer}>
                    <div className={styles.square} style={{ width: "40px", height: "40px" }} />
                    <div className={styles.infoHeaderTextContainer}>
                        <div className={styles.line} style={{ width: "52%" }} />
                        <div className={styles.line} style={{ width: "75%", marginTop: "10px", height: "12px" }} />
                    </div>
                </div>
            </div>
            <div className={styles.paymentMethodContainer}>
                <div>
                    <div className={styles.singleLine}>
                        <div className={styles.circle} />
                        <div className={styles.line} style={{ width: "82%", height: "24px" }} />
                    </div>
                    <div className={styles.singleLine}>
                        <div className={styles.circle} />
                        <div className={styles.line} style={{ width: "82%", height: "24px" }} />
                    </div>
                </div>
                <Title lineWidth={82} />
                <div className={styles.amountSuggestionsContainer}>
                    <div className={styles.suggestion} />
                    <div className={styles.suggestion} />
                    <div className={styles.suggestion} />
                    <div className={styles.suggestion} />
                </div>
            </div>

            <div className={styles.line} style={{ width: "80%", height: "16px" }} />

            <div className={styles.paymentButton} data-testid={LOADING_SCREEN_TEST_IDS.CONTAINER}></div>
        </>
    );
}

export default memo(withStyles<InitalLoadingScreenProps>(SwiggyMoneyLoadingScreen, styles));
